import React, { useEffect, useState } from "react";
import { Icon } from "@mui/material";
import { Favorite, FavoriteBorder, Reply } from "@mui/icons-material";
import { get } from "services/post/PartnershipService";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import SectionVideos from "componentsTemplate/Sections/SectionVideos";
import SectionFotos from "components/fotos/SectionFotos";
import Comments from "components/comments/comments";
import Contact from "components/contact/contact";
import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
import Map from "components/maps/Map";
import Advertising from "components/ad/Advertising";
import placeholder from "images/placeholder-small.png";

const PartnerCompanies: React.FC = () => {
  const [mosaicImg, setMosaicImg] = useState(
    "https://images.unsplash.com/photo-1530789253388-582c481c54b0?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  );
  const [isFavorite, setIsFavorite] = useState(false);
  const [data, setData]: any = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await get(id);
      setData(response.data);

      setLoading(false);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  return (
    <div className="w-full h-full">
      {loading ? (
        <div className="my-20 lg:my-40 spinner border-primary-600"></div>
      ) : (
        <>
          <div className="flex items-center w-full overflow-hidden justify-center mb-2">
            <div
              style={{
                backgroundImage: `url(${
                  urlBase +
                  "/storage/images/posts/partnerships/banners/" +
                  data.banner_path
                })`,
              }}
              className="flex justify-center items-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-[40vw] sm:h-[27vw] bg-cover bg-center"
            >
              <div className="flex bg-black bg-opacity-50 w-full h-full justify-between px-8 md:px-12 items-center">
                <div className="flex flex-col items-center lg:items-start gap-y-2 sm:gap-y-6 md:gap-y-12">
                  <button className="w-fit rounded-full bg-primary-900 text-white text-sm md:text-base px-2 md:px-4 py-1 md:py-2 hover:bg-primary-600">
                    {data.category?.name ?? "-"}
                  </button>
                  <span className="font-semibold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-white">
                    {data.name ?? "-"}
                  </span>
                </div>

                <div className="h-full flex flex-col justify-center gap-y-2 sm:gap-y-6 items-end">
                  <img
                    alt="partner logo"
                    className="object-cover w-16 h-16 sm:w-28 sm:h-28 lg:w-40 lg:h-40 xl:w-60 xl:h-60 bg-primary-600 bg-opacity-60 rounded-3xl"
                    src={
                      urlBase +
                      "/storage/images/posts/partnerships/logos/" +
                      data.logo_path
                    }
                    onError={(e) => (e.currentTarget.src = placeholder)}
                  />
                  <div
                    className="flex justify-center items-center bg-white bg-opacity-40 rounded-full w-9 h-9 xl:w-12 xl:h-12 shadow-md hover:bg-opacity-70 cursor-pointer"
                    onClick={() => {
                      setIsFavorite(!isFavorite);
                    }}
                  >
                    <Icon
                      className="text-white"
                      component={isFavorite ? Favorite : FavoriteBorder}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span className="desktop-margin w-full text-xs sm:text-base px-8 sm:px-0 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
            <Link to={"/"}>Home</Link> &gt;{" "}
            <Link to={"/parceiros"}>Empresas-Parceiras</Link> &gt; {data.name}
          </span>
          <div className="desktop-margin flex flex-col lg:flex-row gap-x-8 px-8 sm:px-0 overflow-hidden w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[79rem] justify-between">
            <div className="w-full pt-10">
              <div>
                <h1 className="font-bold text-xl sm:text-2xl">
                  Benefícios e Descontos
                </h1>
                <p className="leading-5 sm:leading-6 mt-5 text-xs sm:text-sm text-justify">
                  <div
                    className="text-justify"
                    dangerouslySetInnerHTML={{
                      __html: data.benefits ?? "-",
                    }}
                  ></div>
                </p>
                {/* <p className="leading-5 sm:leading-6 mt-3 text-xs sm:text-sm text-justify">Nunc lacus erat, porttitor at orci nec, facilisis commodo urna. Cras placerat lacinia lacus, eget ornare augue elementum at. Donec tincidunt ligula vitae vestibulum cursus. Integer ac venenatis velit. Quisque vitae ligula dolor. Suspendisse vestibulum, diam eget placerat rutrum, elit ex mattis justo, et egestas nulla lorem eget elit.</p> */}
              </div>
              <div>
                <h1 className="mt-10 font-bold text-xl sm:text-2xl">
                  Detalhes
                </h1>

                <p className="leading-5 sm:leading-6 mt-5 text-xs sm:text-sm">
                  <div
                    className="text-justify"
                    dangerouslySetInnerHTML={{
                      __html: data.description ?? "-",
                    }}
                  ></div>
                </p>
              </div>
              <div className="">
                <h1 className="font-bold mt-10 text-xl sm:text-2xl">
                  Sobre a Empresa
                </h1>
                <p className="leading-5 sm:leading-6 mt-5 text-xs sm:text-sm text-justify">
                  <div
                    className="text-justify"
                    dangerouslySetInnerHTML={{
                      __html: data.about_us ?? "-",
                    }}
                  ></div>
                </p>
              </div>

              <div className="mt-16">
                {data.address?.address && data.address?.number && (
                  <>
                    <div>
                      <h1 className="font-bold mt-10 text-xl sm:text-2xl">
                        Localização
                      </h1>
                      {/* Aqui usamos o componente Map passando o endereço como prop */}
                      <Map address={`${data.address?.address}, ${data.address?.number}, ${data.address?.city}, ${data.address?.state}, ${data.address?.country}`} />
                    </div>

                    <p className="leading-5 sm:leading-6 mt-5 text-xs sm:text-sm text-justify">
                      {
                        `${data.address?.address} ${' '} ${data.address?.number} ${data.address?.complement ? ' ' + data.address?.complement : '' }, ${data.address?.city} ${' '} ${data.address?.state} ${' '} ${data.address?.country}`
                      }
                    </p>
                  </>         
                )}
              </div>

            </div>

            <div className="flex flex-1 flex-col h-fit items-center lg:items-end pt-5 gap-y-10">
              <a href={data.url} target="_blank">
                <div style={{ top: "25px", position: "relative" }}>
                  {data.url != null ? data.url : null}
                </div>
              </a>

              <div className="flex">
                {data.facebook != null ? (
                  <a href={data.facebook} target="_blank" rel="noreferrer">
                    <div className="p-0-25 click">
                      <FaFacebookSquare size={30} />
                    </div>
                  </a>
                ) : null}

                {data.instagram != null ? (
                  <a href={data.instagram} target="_blank" rel="noreferrer">
                    <div className="p-0-25 click">
                      <FaInstagramSquare size={30} />
                    </div>
                  </a>
                ) : null}

                {data.tiktok != null ? (
                  <a href={data.tiktok} target="_blank" rel="noreferrer">
                    <div className="p-0-25 click">
                      <FaTiktok size={30} />
                    </div>
                  </a>
                ) : null}

                {data.youtube != null ? (
                  <a href={data.youtube} target="_blank" rel="noreferrer">
                    <div className="p-0-25 click">
                      <FaYoutube size={30} />
                    </div>
                  </a>
                ) : null}

                {data.linkedin != null ? (
                  <a href={data.linkedin} target="_blank" rel="noreferrer">
                    <div className="p-0-25 click">
                      <FaLinkedin size={30} />
                    </div>
                  </a>
                ) : null}
              </div>
              {data.url_video && (
                <div className="w-full h-[12rem] sm:w-full sm:h-[20rem] md:w-[40rem] md:h-[23rem] lg:w-full lg:h-[16rem] border-[#F8F8F8] dark:border-[#1D2432] rounded-3xl border-8 overflow-hidden">
                  <iframe
                    width="100%"
                    height="100%"
                    src={data.url_video}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  ></iframe>
                </div>
              )}

              <Contact post_type_id={5} post_id={data.post_id} />
            </div>
          </div>

          {data && data.attachments && data.attachments.length > 0 && (
            <div className="desktop-margin mb-10">
              <div className=" w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] px-3 md:px-0">
                <SectionFotos
                  attachments={data.attachments}
                  className="py-10 lg:py-10"
                  url="/storage/images/posts/partnerships/attachments/"
                />
              </div>
            </div>
          )}

          <div className="flex flex-col md:flex-row justify-between w-full gap-5 desktop-margin px-8 sm:px-0 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">

          
            {/* Comentários ocupam o espaço restante da tela */}
            <div className="w-full md:flex-grow pb-20">
              <Comments
                dados={data}
                tela="partnerships"
                url="/posts/partnerships/comment"
                urlAnswer="/posts/partnerships/answer"
                get={fetchData}
                classe="flex flex-col w-full"
              />
            </div>

            {/* Anúncio com largura cheia no mobile e largura fixa em telas maiores */}
            <div className="w-full md:w-[300px] lg:w-[400px] mt-5 md:mt-0 pb-10">
              <Advertising type="vertical" subCategoryId={data?.subcategory?.id} />
            </div>
          </div>

          <div className="mx-4 lg:mx-[16vw] my-10">
            <Advertising type="horizontal" />
          </div>
        </>
      )}
    </div>
  );
};

export default PartnerCompanies;
